var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlinSimbolo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4868 9.53674e-06H29.5134V10.1371H24.5001C21.7313 10.1371 19.4868 7.89263 19.4868 5.1238V9.53674e-06Z",
    fill: "#0047BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6311 10.7208L10.721 3.63097L17.8889 10.7989L14.3441 14.344C12.3861 16.3017 9.21198 16.3017 7.25424 14.344L3.6311 10.7208Z",
    fill: "#0047BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 29.5132V19.4867H10.1371V24.5C10.1371 27.2688 7.89262 29.5132 5.12379 29.5132H0Z",
    fill: "#0047BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7207 45.369L3.63086 38.2792L10.7988 31.1112L14.3438 34.656C16.3016 36.614 16.3016 39.7881 14.3438 41.7459L10.7207 45.369Z",
    fill: "#0047BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5131 49H19.4866V38.8629H24.4999C27.2687 38.8629 29.5131 41.1074 29.5131 43.8762V49Z",
    fill: "#0047BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3691 38.2792L38.2793 45.3691L31.1113 38.2011L34.6561 34.6561C36.6141 32.6984 39.7883 32.6984 41.746 34.6561L45.3691 38.2792Z",
    fill: "#0047BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0001 19.4868V29.5134H38.863V24.5001C38.863 21.7312 41.1075 19.4868 43.8763 19.4868H49.0001Z",
    fill: "#0047BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2792 3.63099L45.369 10.7208L38.2011 17.8888L34.656 14.344C32.6983 12.386 32.6983 9.21187 34.656 7.25413L38.2792 3.63099Z",
    fill: "#0047BA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlinSimbolo);
export default __webpack_public_path__ + "static/media/plin-simbolo.0d995231102cb009ed73fb609d009239.svg";
export { ForwardRef as ReactComponent };